export function splitIntoEqualLines(str, numLines) {
    if (numLines <= 0) return [];

    const words = str.split(/\s+/);
    const totalLen = str.length;
    const targetLen = Math.ceil(totalLen / numLines);

    const lines = [];
    let currentLine = "";
    let currentLen = 0;

    for (const word of words) {
        // +1 for space if not first word
        const addLen = (currentLine ? 1 : 0) + word.length;

        if (currentLen + addLen > targetLen && lines.length < numLines - 1) {
            // push current line and start a new one
            lines.push(currentLine);
            currentLine = word;
            currentLen = word.length;
        } else {
            currentLine += (currentLine ? " " : "") + word;
            currentLen += addLen;
        }
    }

    if (currentLine) lines.push(currentLine);

    return lines;
}